import createPersistedState from 'vuex-persistedstate'
import Vue from 'vue'
import Vuex from 'vuex'
import state from './moudle/state'
import mutations from './moudle/mutations'
import getters from './moudle/getters'
import actions from './moudle/actions'



Vue.use(Vuex);

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    plugins: [
        createPersistedState({
            storage: window.sessionStorage
        })
    ]
})